<script>
  import * as Status from '../../../../domain/leiloes/helpers/LeilaoStatus'
  export default{
    name: 'pregao-menu-stats',
    props: ['pregao', 'leilao', 'stats'],
    data () {
      return {}
    },
    computed: {
      isPregaoAtivo: function () {
        return this.pregao !== null && typeof this.pregao !== 'undefined'
      },
      classStatus: function () {
        return {
          aberto: this.isPregaoAtivo
        }
      },
      getStatus () {
        return Status.Status
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      abrirPregao () {
        this.$confirm.open('Tem certeza que deseja abrir este leilão e colocá-lo em pregão? ', 'Abrir Leilão', 'Cancelar', null, this.confirmAbrirPregao)
      },
      confirmAbrirPregao (v) {
        if (v === false) {
          return
        }
        console.log('Abrindo pregao...')
        this.$emit('abrirPregao')
      },
      HelperTipo (v) {
        return v !== null && typeof v !== 'undefined' ? Status.Tipo[v] : '-'
      }
    },
    components: {}
  }
</script>

<template>
  <div class="pstats">
    <div class="pstats-itens">
      <div>
        Tipo: <span>{{HelperTipo(leilao.tipo)}}</span>
      </div>
      <div>
        Lotes: <span>{{ (pregao !== null ? pregao.totalLotes : 0) | number }}</span>
      </div>
      <div>
        Arrematantes Online: <span>{{ stats.arrematantesOnline | number }}</span>
      </div>
      <div>
        Espectadores: <span>{{ stats.espectadoresOnline | number }}</span>
      </div>
      <div>
        Comitentes Online: <span>{{ stats.comitentesOnline | number }}</span>
      </div>
      <div class="leilao-aberto">
        Status do Leilão:
        <span v-shortkey="['f4']" @shortkey="abrirPregao" @click="abrirPregao" v-if="!isPregaoAtivo" title="Clique para abrir">Fechado <i class="shoutcut">F4 para abrir</i></span>
        <span v-else class="aberto">Aberto </span>
      </div>
    </div>
    <div class="pstats-buttons">
      <a title="Monitorar Servidor" class="server-monitor">Monitor</a>
      <a title="Vídeo ao vivo" class="streaming">Streaming</a>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Stats.vue?b3eed9b6